import { devError } from '../../utils/log';

const STORAGE_KEY = 'stampCardSeenProgress';

const MAX_TRACKED_CARDS = 20;

type SeenProgress = Record<string, number>;

function readAll(): SeenProgress {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);

    return raw ? (JSON.parse(raw) as SeenProgress) : {};
  } catch (error) {
    devError('Error reading seen stamp progress', error);

    return {};
  }
}

export function readSeenStampCount(userStampCardId: string): number {
  return readAll()[userStampCardId] ?? 0;
}

export function writeSeenStampCount(userStampCardId: string, stampsCompleted: number): void {
  try {
    const all = readAll();

    if ((all[userStampCardId] ?? 0) >= stampsCompleted) return;

    all[userStampCardId] = stampsCompleted;

    const trimmed = Object.entries(all).slice(-MAX_TRACKED_CARDS);

    localStorage.setItem(STORAGE_KEY, JSON.stringify(Object.fromEntries(trimmed)));
  } catch (error) {
    devError('Error saving seen stamp progress', error);
  }
}
